import i18n from 'services/i18n'

const TRIAL_FORM = i18n.t('Url.trial_form')
const FREE_SUBSCRIPTIONS = i18n.t('Url.free_subscriptions_form')
const FREE_SUBSCRIPTIONS_THANK_YOU = i18n.t('Url.free_subscriptions_thank_you')
const ORGANIZATION_LICENSE = i18n.t('Url.organization_licence')
const ALREADY_LOGGED_IN = i18n.t('Url.already_logged_in')
const NO_ACCESS = i18n.t('Url.no_access')
const CONTENT_EXPIRED = i18n.t('Url.content_expired')
const SERVICE = i18n.t('Url.service')
const COURSES = i18n.t('Url.courses')
const COURSE_COLLECTION = i18n.t('Url.course_collection')
const LIVE_EVENTS = i18n.t('Url.live_events')
const VIRTUAL_CLASSROOMS = i18n.t('Url.virtual_classrooms')
const NEW_PASSWORD = i18n.t('Url.new_password')
const CHANGE_PASSWORD = i18n.t('Url.change_password')
const PAGE_NOT_FOUND = i18n.t('Url.page_not_found')
const ALL_PACKAGES = i18n.t('Url.all_packages')
const ALL_CONTENT = i18n.t('Url.all_content')
const LOGIN = i18n.t('Url.login')
const SSO_JOIN = i18n.t('Url.sso_join')
const CURRENTLY_UNAVAILABLE = i18n.t('Url.currently_unavailable')
const SOMETHING_WENT_WRONG = i18n.t('Url.something_went_wrong')
const LEARNING_PATH = i18n.t('Url.learning_path')
const UPGRADE_NOTICE = i18n.t('Url.upgrade_notice')
const ACCESSIBILITY_STATEMENT = i18n.t('Url.accessibility_statement')

export const NAMES = {
    SSO_JOIN: 'sso-join',
    COLLECTION_PAGE: 'collection-page',
    COLLECTION_PAGE_WITHOUT_PACKAGE: 'collection-without-package',
    LEARNING_PATH_PAGE: 'learning-path-page',
    LEARNING_PATH_PAGE_WITHOUT_PACKAGE: 'learning-path-without-package',
}

const createLink = (parts) => '/' + parts.filter(el => el).join('/')

export const LINKS = {
    SERVICE: createLink([SERVICE]),
    COURSE_WITHOUT_PACKAGE: createLink([SERVICE, COURSES, ':courseSlug']),
    COURSE_WITHOUT_PACKAGE_LIVE: createLink([SERVICE, COURSES, 'live', ':courseSlug']),
    COURSE_WITHOUT_PACKAGE_VIRTUAL_CLASSROOMS: createLink([SERVICE, COURSES, VIRTUAL_CLASSROOMS, ':courseSlug']),
    COURSE_WITHOUT_PACKAGE_WITH_COLLECTION_SLUG: createLink([SERVICE, COURSES, ':courseSlug', COURSE_COLLECTION, ':collectionSlug']),
    COLLECTION_WITHOUT_PACKAGE: createLink([SERVICE, COURSE_COLLECTION, ':collectionSlug']),
    LEARNING_PATH_WITHOUT_PACKAGE: createLink([SERVICE, LEARNING_PATH, ':learningPathSlug']),
    LOGIN: createLink([SERVICE, LOGIN]),
    LOGIN_SSO_DEDICATED: createLink([SERVICE, LOGIN, ':serviceId']),
    LOGIN_SSO_CALLBACK: createLink([SERVICE, LOGIN, 'sso', 'callback', ':serviceId']),
    SET_PASSWORD: createLink([SERVICE, CHANGE_PASSWORD, ':token']),
    NEW_PASSWORD: createLink([SERVICE, NEW_PASSWORD]),
    PAGE_NOT_FOUND: createLink([SERVICE, PAGE_NOT_FOUND]),
    PAGE_NO_PERMISSION: createLink([SERVICE, NO_ACCESS]),
    PAGE_CONTENT_EXPIRED: createLink([SERVICE, CONTENT_EXPIRED]),
    PAGE_ALREADY_SIGNED_IN: createLink([SERVICE, ALREADY_LOGGED_IN]),
    PAGE_CURRENTLY_UNAVAILABLE: createLink([SERVICE, CURRENTLY_UNAVAILABLE]),
    PAGE_SOMETHING_WENT_WRONG: createLink([SERVICE, SOMETHING_WENT_WRONG]),
    PAGE_UPGRADE_NOTICE: createLink([SERVICE, UPGRADE_NOTICE, ':collectionSlug']),
    TRIAL_FORM: createLink([SERVICE, TRIAL_FORM, ':slug']),
    FREE_SUBSCRIPTIONS: createLink([SERVICE, FREE_SUBSCRIPTIONS, ':slug']),
    FREE_SUBSCRIPTIONS_THANK_YOU: createLink([SERVICE, FREE_SUBSCRIPTIONS, ':slug', FREE_SUBSCRIPTIONS_THANK_YOU]),
    AGREEMENT_FORM: createLink([SERVICE, ORGANIZATION_LICENSE, ':slug']),
    SSO_JOIN: createLink([SERVICE, SSO_JOIN]),
    USER: createLink([SERVICE, 'user']),
    ALL_PACKAGES_ALL_CONTENT: createLink([SERVICE, ALL_PACKAGES, ALL_CONTENT]),
    ALL_PACKAGES_COURSE_LIST: createLink([SERVICE, ALL_PACKAGES, COURSES]),
    ALL_PACKAGES_COLLECTION_LIST: createLink([SERVICE, ALL_PACKAGES, COURSE_COLLECTION]),
    ALL_PACKAGES_LIVE_EVENTS: createLink([SERVICE, ALL_PACKAGES, LIVE_EVENTS]),
    ALL_PACKAGES_VIRTUAL_CLASSROOMS: createLink([SERVICE, ALL_PACKAGES, VIRTUAL_CLASSROOMS]),
    ALL_PACKAGES_LEARNING_PATHS: createLink([SERVICE, ALL_PACKAGES, LEARNING_PATH]),
    ALL_CONTENT: createLink([SERVICE, ':packageSlug', ALL_CONTENT]),
    COURSE_LIST: createLink([SERVICE, ':packageSlug', COURSES]),
    COLLECTION_LIST: createLink([SERVICE, ':packageSlug', COURSE_COLLECTION]),
    LEARNING_PATHS: createLink([SERVICE, ':packageSlug', LEARNING_PATH]),
    LIVE_EVENTS: createLink([SERVICE, ':packageSlug', LIVE_EVENTS]),
    VIRTUAL_CLASSROOMS: createLink([SERVICE, ':packageSlug', VIRTUAL_CLASSROOMS]),
    COURSE_LIST_COURSE_PAGE: createLink([SERVICE, ':packageSlug', COURSES, ':courseSlug']),
    COURSE_LIST_COURSE_PAGE_LIVE: createLink([SERVICE, ':packageSlug', COURSES, 'live', ':courseSlug']),
    COLLECTION_PAGE: createLink([SERVICE, ':packageSlug', COURSE_COLLECTION, ':collectionSlug']),
    COLLECTION_PAGE_COURSE_PAGE: createLink([SERVICE, ':packageSlug', COURSE_COLLECTION, ':collectionSlug', ':courseSlug']),
    COLLECTION_PAGE_COURSE_PAGE_LIVE: createLink([SERVICE, ':packageSlug', COURSE_COLLECTION, ':collectionSlug', 'live', ':courseSlug']),
    COLLECTION_PAGE_COURSE_PAGE_WITHOUT_PACKAGE: createLink([SERVICE, COURSE_COLLECTION, ':collectionSlug', ':courseSlug']),
    COLLECTION_PAGE_COURSE_PAGE_LIVE_WITHOUT_PACKAGE: createLink([SERVICE, COURSE_COLLECTION, ':collectionSlug', 'live', ':courseSlug']),
    COLLECTION_PAGE_COURSE_PAGE_VIRTUAL_CLASSROOMS: createLink([SERVICE, ':packageSlug', COURSE_COLLECTION, ':collectionSlug', VIRTUAL_CLASSROOMS, ':courseSlug']),
    COURSE_LIST_COURSE_PAGE_VIRTUAL_CLASSROOMS: createLink([SERVICE, ':packageSlug', COURSES, VIRTUAL_CLASSROOMS, ':courseSlug']),
    COLLECTION_PAGE_COURSE_PAGE_VIRTUAL_CLASSROOMS_WITHOUT_PACKAGE: createLink([SERVICE, COURSE_COLLECTION, ':collectionSlug', VIRTUAL_CLASSROOMS, ':courseSlug']),
    LEARNING_PATH_PAGE: createLink([SERVICE, ':packageSlug', LEARNING_PATH, ':learningPathSlug']),
    LEARNING_PATH_PAGE_COURSE_PAGE: createLink([SERVICE, ':packageSlug', LEARNING_PATH, ':learningPathSlug', ':courseSlug']),
    LEARNING_PATH_PAGE_COURSE_PAGE_LIVE: createLink([SERVICE, ':packageSlug', LEARNING_PATH, ':learningPathSlug', 'live', ':courseSlug']),
    LEARNING_PATH_PAGE_COURSE_PAGE_WITHOUT_PACKAGE: createLink([SERVICE, LEARNING_PATH, ':learningPathSlug', ':courseSlug']),
    LEARNING_PATH_PAGE_COURSE_PAGE_LIVE_WITHOUT_PACKAGE: createLink([SERVICE, LEARNING_PATH, ':learningPathSlug', 'live', ':courseSlug']),
    LEARNING_PATH_PAGE_COURSE_PAGE_VIRTUAL_CLASSROOMS: createLink([SERVICE, ':packageSlug', LEARNING_PATH, ':learningPathSlug', VIRTUAL_CLASSROOMS, ':courseSlug']),
    LEARNING_PATH_PAGE_COURSE_PAGE_VIRTUAL_CLASSROOMS_WITHOUT_PACKAGE: createLink([SERVICE, LEARNING_PATH, ':learningPathSlug', VIRTUAL_CLASSROOMS, ':courseSlug']),
    ACCESSIBILITY_STATEMENT: createLink([SERVICE, ACCESSIBILITY_STATEMENT])
}

export const getTrialFormRoute = () => {
    return { name: 'free-subscriptions', params: { slug: i18n.t('General.start_trial_url_slug') } }
}

export const getDefaultLoggedInRoute = () => {
    return { name: 'home' }
}
